import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Flex, Text, Heading, View, useTheme } from "@aws-amplify/ui-react";
import { useContx } from "../../AuthProvider";
import Header from "../tables/Header";
import Config from "../../config";
import { DeleteFormProps } from "@/types";
import FormActions from "./FormActions";

const DeleteForm = ({ title }: DeleteFormProps) => {
  const { loading, deleteMission, deleteLog, deleteBoat } = useContx();
  const { tokens } = useTheme();
  const { state } = useLocation();
  const navigate = useNavigate();

  const isMission = title === "Expedition";
  const isBoat = title === "Boat";
  const isLog = title === "Log";

  const onSubmit = async () => {
    if (isMission) {
      await deleteMission(state.id);
      navigate(Config.routes.missions);
    }

    if (isBoat) {
      await deleteBoat(state.id);
      navigate(Config.routes.boats);
    }

    if (isLog) {
      await deleteLog(state.id);
      navigate(Config.routes.agencies);
    }
  };

  let isDisabledCheck = loading;

  const t = `Delete ${title}`;

  return (
    <>
      <Header title={t} />
      <Flex
        direction={{ base: "column", large: "row" }}
        alignItems="stretch"
        gap={tokens.space.xl}
        minHeight="15vh"
      >
        <View
          backgroundColor="var(--amplify-colors-white)"
          borderRadius="6px"
          width={{ base: "100%", large: "70%" }}
          padding="1rem"
          minHeight="15vh"
        >
          <Flex direction="column" width="100%">
            <Heading level={5}>
              Are you sure you want to delete this {title.toLowerCase()}?
            </Heading>
            {isMission && (
              <>
                <Text>Name: {state.name}</Text>
                <Text>Start Date: {new Date(state.date_start).toLocaleDateString()}</Text>
                <Text>End Date: {new Date(state.date_end).toLocaleDateString()}</Text>
              </>
            )}
            {isBoat && (
              <>
                <Text>Name: {state.name}</Text>
                <Text>Model: {state.model}</Text>
              </>
            )}
            {isLog && (
              <>
                <Text>Filename: {state.filename}</Text>
              </>
            )}
            <Text color="red">This action cannot be undone.</Text>
          </Flex>
        </View>
        <View
          backgroundColor="var(--amplify-colors-white)"
          borderRadius="6px"
          width={{ base: "100%", large: "30%" }}
          padding="1rem"
          minHeight="15vh"
          height="fit-content"
        >
          <FormActions
            text="Delete"
            formOnSubmit={onSubmit}
            isLoading={loading}
            isDisabled={isDisabledCheck}
          />
        </View>
      </Flex>
    </>
  );
};

export default DeleteForm;